import margemBruta from "./margemBruta";
import simuladorFolha from "./simuladorFolha";
import custosPorProjeto from "./custosPorProjeto";
import backlog2027 from "./backlog2027";

// União dos allowedRoles de cada sub-módulo: garante que o card "Módulos
// Operacionais" apareça para quem tem acesso a pelo menos um deles. Dentro da
// página, cada sub-módulo continua sendo filtrado pelo seu próprio allowedRoles.
const subModulos = [margemBruta, simuladorFolha, custosPorProjeto, backlog2027];

const allowedRoles = Array.from(
  new Set(subModulos.flatMap((m) => m.allowedRoles || []))
);

const modulosOperacionais = {
  id: "modulos-operacionais",
  titulo: "Monitoramento de Custos e Margem Bruta",
  icone: "Layers",
  allowedRoles,
  descricao:
    "Documentação reunida dos módulos operacionais: Margem Bruta, Simulador de Folha, Custos por Projeto e Backlog 2027.",
  subModulos,
};

export default modulosOperacionais;
